import '@lottiefiles/lottie-player';
import { create } from '@lottiefiles/lottie-interactivity';
export default function initValeurs(): void {
    const $containerBlockValeurs = document.querySelectorAll<HTMLElement>('.block-valeurs');

    $containerBlockValeurs.forEach($container => {
        new BlockValeurs($container);
    });
}

class BlockValeurs {
    $el: HTMLElement | null | undefined;
    $lottie:  HTMLElement | null | undefined;
    $lottieContainer:  HTMLElement | null | undefined;

    constructor($el: HTMLElement | null) {
        this.$el = $el;
        this.$lottie = $el.querySelector("#logo-lottie");
        this.$lottieContainer = $el.querySelector("#lottie-container");
        this.init();
    }

    init(): void {
        if (this.$lottie && this.$lottieContainer) {
            this.$lottie.addEventListener('load', () => {
                create({
                    player: this.$lottie,
                    mode:"scroll",
                    container: this.$lottieContainer,
                    actions: [
                        {
                            visibility:[0, 1.0],
                            type: "seek",
                            frames: [0, 420],
                        },
                    ]
                });
            });
        }

        this.initStickyTop();

        window.addEventListener('resize', () => {
            this.initStickyTop();
        });
    }

    initStickyTop() {
        const logoElement = this.$el?.querySelector('#logo-lottie') as HTMLElement;
    
        if (logoElement) {
            const logoHeight = logoElement.offsetHeight;
            if (logoHeight < 250) {
                setTimeout(() => {
                    this.initStickyTop();
                }, 500);
                return;
            }
        
            const windowHeight = window.innerHeight;
            const stickyTop = ((windowHeight - logoHeight) / 2) + 58;
        
            const lottiePlayerContainer = document.querySelector<HTMLElement>('.block-valeurs .lottie-player-container');
            if (lottiePlayerContainer) {
                lottiePlayerContainer.style.top = `${stickyTop}px`;
            }
        }
    }
}
